import ColorPicker from "components/ColorPicker"
import { SingleSelectField, TextField } from "components/RenderInput"
import UnsavedAlertModal from "components/UnsavedAlertModal"
import { FORM_NAMES } from "constants/index"
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field, isDirty, reset } from "redux-form"

export const required = value =>
  value ? undefined : "The calendar name is required"

const SetUpTab = ({
  businessUnits,
  handleSave,
  tabIsActive,
  resetForm,
  isDirty,
}) => {
  const [showAlertModal, setShowAlertModal] = useState(false)

  useEffect(() => {
    if (!tabIsActive && isDirty) {
      setShowAlertModal(true)
    }
  }, [tabIsActive])

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card className="mt-3">
            <CardHeader>
              <h4>SET A NAME/COLOR FOR YOUR CALENDAR</h4>
            </CardHeader>
            <CardBody>
              <Row className="my-3">
                <Col xs="auto" style={{ minWidth: "188px" }}>
                  <label>Name of calendar: </label>
                </Col>
                <Col xs="auto" style={{ minWidth: "290px" }}>
                  <Field
                    name="name"
                    component={TextField}
                    placeholder="Name"
                    validate={[required]}
                  />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs="auto" style={{ minWidth: "188px" }}>
                  <label>Color of calendar: </label>
                </Col>
                <Col xs="auto" style={{ minWidth: "290px" }}>
                  <Field name="color" component={ColorPicker} />
                </Col>
              </Row>
              <Row className="my-3">
                <Col xs="auto" style={{ minWidth: "188px" }}>
                  <label>Business unit: </label>
                </Col>
                <Col xs="auto">
                  <div style={{ minWidth: "270px" }}>
                    <Field
                      name="businessUnit"
                      component={SingleSelectField}
                      options={[
                        { value: null, label: "No Business Unit" },
                        ...businessUnits?.map(bu => ({
                          value: bu?.id,
                          label: bu?.name,
                        })),
                      ]}
                      placeholder="No Business Unit"
                    />
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <UnsavedAlertModal
        isOpen={showAlertModal}
        onClose={() => {
          setShowAlertModal(false)
          resetForm()
        }}
        onSave={() => {
          handleSave()
          setShowAlertModal(false)
        }}
      />
    </React.Fragment>
  )
}

const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits,
  isDirty: isDirty(FORM_NAMES.EVENT_CALENDAR)(state, ...["setUp"]),
})

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset(FORM_NAMES.EVENT_CALENDAR)),
})

export default connect(mapStateToProps, mapDispatchToProps)(SetUpTab)
